import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-picview",
  "use": "icon-picview-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-picview\"><defs><style type=\"text/css\"></style></defs><path d=\"M512 237.7152C237.7152 237.7152 128 512 128 512s109.7152 274.2912 384 274.2912S896 512 896 512 786.2848 237.7152 512 237.7152L512 237.7152zM512 676.576c-90.8544 0-164.5696-73.664-164.5696-164.576 0-90.9056 73.7152-164.5696 164.5696-164.5696S676.5696 421.088 676.5696 512C676.5696 602.912 602.8544 676.576 512 676.576L512 676.576zM512 676.576M594.2784 512c0 45.4272-36.8512 82.2912-82.2784 82.2912S429.7216 557.4272 429.7216 512c0-45.4272 36.8512-82.2784 82.2784-82.2784C557.4336 429.7088 594.2784 466.5664 594.2784 512L594.2784 512zM594.2784 512\" p-id=\"28863\" fill=\"#8a8a8a\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/picview.svg
// module id = ZD7a
// module chunks = 22